import confetti from "canvas-confetti";

export default function Confetti() {
	// leaf shape from ionicon
	const leaf = confetti.shapeFromPath({
		path: "M150.38 253.68l21.94-23.3 11.65 11c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.25-26-76.6-32.09-115.09-38.54-21.12-3.54-43-7.2-66.85-14.43-43.7",
		matrix: [
			0.03597122302158273, 0, 0, 0.03597122302158273, -4.856115107913669,
			-5.071942446043165,
		],
	});

	const defaults = {
		particleCount: 250,
		scalar: 2.5,
		spread: 200,
		origin: { y: -0.1 },
		startVelocity: 100,
		gravity: 3,
		ticks: 500,
		disableForReducedMotion: true,
	};

	const checkForConfetti = document.querySelector(".confetti-active");

	if (checkForConfetti) {
		confetti({
			...defaults,
			shapes: [leaf],
			colors: ["#84cc16", "#4d7c0f"],
		});
	}
}
